import React from 'react';
import { ids, COLORS } from 'apps/web_forms/utils/constants';
import Modal from 'apps/web_forms/components/commons/Modal';

export const ResourceUpdateConfirmationModal = ({ extraProps }) => {
  const {
    setUpdateResourceConfirmationOpen,
    updateResources,
    numAffectedFields,
  } = extraProps || {};

  return (
    <Modal
      mainMessage='Are you sure you want to update?'
      helpTip={
        <>
          By updating the resource <b>{numAffectedFields} QUESTIONS</b> will be impacted.<br/>
          After an update, you will be guided through reviewing questions that have changed.
        </>
      }
      isOpen={true}
      setIsOpen={setUpdateResourceConfirmationOpen}
      testId={ids.FormIds.UpdateResourceConfirmationModal}
      buttons={[
        {
          id: ids.FormIds.UpdateResourceConfirmationButton,
          label: 'Update',
          onClick: updateResources,
          filled: true,
        },
        {
          id: ids.FormIds.UpdateResourceCancelButton,
          label: 'Cancel',
          onClick: () => setUpdateResourceConfirmationOpen(false),
          filled: false,
          materialText: true,
          mainColor: COLORS.red,
        },
      ]}
    />
  );
};
